import { render, staticRenderFns } from "./CardReport.vue?vue&type=template&id=247b6858&scoped=true&"
import script from "./CardReport.vue?vue&type=script&lang=js&"
export * from "./CardReport.vue?vue&type=script&lang=js&"
import style0 from "./CardReport.vue?vue&type=style&index=0&id=247b6858&lang=scss&scoped=true&"
import style1 from "./CardReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b6858",
  null
  
)

export default component.exports